import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [checkedLogin, setCheckedLogin] = useState(false); // evita loop do useEffect

  // ✅ Verifica token apenas 1x ao montar o componente
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dashboard", { replace: true });
    } else {
      setCheckedLogin(true);
    }
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return; // evita duplo clique

    setError(null);
    setLoading(true);

    try {
      if (typeof login !== "function") {
        throw new Error("Função de login não encontrada — verifique o AuthProvider.");
      }

      await login(email.trim(), senha);
      navigate("/dashboard", { replace: true }); // redireciona após sucesso
    } catch (err: any) {
      console.error("Erro no login:", err);
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Falha ao fazer login. Verifique suas credenciais.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  // 🔒 Evita renderização antes da checagem do token
  if (!checkedLogin) return null;

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{ background: "linear-gradient(135deg,#003366,#5a3e2b)" }}
    >
      <form
        onSubmit={handleSubmit}
        className="bg-white p-4 rounded-3 shadow"
        style={{ width: 380 }}
      >
        <h3 className="text-center mb-3" style={{ color: "#003366" }}>
          Acesso ao Sistema
        </h3>

        {error && <div className="alert alert-danger">{error}</div>}

        <div className="mb-3">
          <label className="form-label">E-mail</label>
          <input
            className="form-control"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Senha</label>
          <input
            className="form-control"
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            required
          />
        </div>

        <div className="d-flex gap-2">
          <button
            type="submit"
            className="btn btn-primary flex-grow-1"
            disabled={loading}
            style={{ backgroundColor: "#003366", borderColor: "#003366" }}
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              setEmail("");
              setSenha("");
              setError(null);
            }}
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
}
